import { TmBaseComponent } from '@treasury/presentation';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export const tagName = 'jhd-data-field';
@customElement(tagName)
export class JhdDataField extends TmBaseComponent {
    @property({ type: String, reflect: true })
    public label = '';

    @property({ type: String, reflect: true })
    public value: string | string[] | Record<string, unknown>[] = '';

    @property({ type: Boolean, reflect: true })
    public edited = false;

    @property({ type: String })
    public valueProperty = '';

    @property({ type: Boolean, reflect: true })
    public isClickable = false;

    @property({ type: Boolean, reflect: true })
    public unemphasize = false;

    protected render() {
        return html`<div class="flex text-sm">
            <span class="label mr-3">${this.label}</span
            ><span
                @click=${() => {
                    if (this.isClickable) {
                        this.dispatchEvent(new Event('dataFieldClick'));
                    }
                }}
                @keydown=${(e: KeyboardEvent) => {
                    if (this.isClickable && e.key === 'Enter') {
                        this.dispatchEvent(new Event('dataFieldClick'));
                    }
                }}
                class="value"
                >${this.renderValue()}</span
            >
        </div>`;
    }

    public get displayValue() {
        if (this.valueProperty && Array.isArray(this.value)) {
            return this.value
                .filter(i => typeof i !== 'string')
                .map(item => html`${item[this.valueProperty]}<br />`);
        }

        if (Array.isArray(this.value)) {
            return this.value.map(value => html`${value}<br />`);
        }

        return this.value;
    }

    private renderValue() {
        if (!this.edited) {
            return html`${this.displayValue}`;
        }
        return html`<span class="edited p-1">${this.displayValue}</span>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    margin: 12px 0;
                }
                .label {
                    color: var(--secondary-text-color, #444444);
                    flex: 1 1 var(--jhd-field-label-width, 155px);
                }
                .value {
                    color: var(--header-text-color, #444444);
                    flex: 3 1 var(--jhd-field-control-width, 160px);
                }
                .edited {
                    background: rgba(255, 153, 0, 0.25);
                    mix-blend-mode: darken;
                }
                :host([isClickable]) .value {
                    color: var(--content-action);
                    cursor: pointer;
                }

                :host([unemphasize]) .value {
                    color: var(--jh-color-gray-300, var(--brand-text-light, #999999));
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: JhdDataField;
    }
}
